import { List } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { IndexListItem } from 'components/styles_components/list';
import ListItem from 'components/template/index/list_item';
import ListHeader from 'components/template/index/list_header';
import LoaderContainer from 'components/layout/loader_container';
import InfoContainer from 'components/info_container';

const Index = ({ templates, sortBy, onSortChange, loading }) => {
  return (
    <List>
      <ListHeader sortBy={sortBy} onSortChange={onSortChange} />
      <LoaderContainer loading={loading} wrap={false} keepRenderedContent={true}>
        {templates.templates.map((template) => (
          <ListItem key={template.id} template={template} />
        ))}
      </LoaderContainer>
      {!loading && templates.templates.length === 0 && (
        <IndexListItem>
          <InfoContainer>
            <FormattedMessage id="empty.templates.title" />
          </InfoContainer>
        </IndexListItem>
      )}
    </List>
  );
};

export default Index;
